var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5139 5.52381L13.4913 5.52392C12.2569 5.5364 11.2663 6.5472 11.2787 7.78163L11.2481 11.0451C11.2427 11.462 10.9032 11.7971 10.4863 11.7971H8.52381V13.1673H10.5219C10.9427 13.1673 11.2838 13.5085 11.2838 13.9292V18.4762H13.103V13.9292C13.103 13.5085 13.4441 13.1673 13.8649 13.1673H15.8059L16.0167 11.7971H13.8649C13.4441 11.7971 13.103 11.456 13.103 11.0352V8.40632C13.103 7.57173 13.7795 6.89512 14.6141 6.89512H16.1428V5.52381H13.5139ZM13.4759 4.00019L13.5139 4H16.9047C17.3255 4 17.6667 4.34112 17.6667 4.7619V7.65702C17.6667 8.07781 17.3255 8.41893 16.9047 8.41893H14.6268V10.2733H16.9047C17.127 10.2733 17.3383 10.3704 17.483 10.5391C17.6278 10.7078 17.6916 10.9313 17.6578 11.151L17.2126 14.0451C17.1554 14.4168 16.8356 14.6911 16.4595 14.6911H14.6268V19.2381C14.6268 19.6589 14.2857 20 13.8649 20H10.5219C10.1012 20 9.76003 19.6589 9.76003 19.2381V14.6911H7.7619C7.34112 14.6911 7 14.35 7 13.9292V11.0352C7 10.6144 7.34112 10.2733 7.7619 10.2733H9.7342L9.75998 8.28703L9.75501 7.79711C9.73403 5.72116 11.3999 4.02122 13.4759 4.00019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bf2d364c.svg";
export { ForwardRef as ReactComponent };